import { Component, signal } from '@angular/core';

import { LockerStatus } from '../../../models/domain.models';

@Component({
  selector: 'vx-digital-twin',
  standalone: true,
  template: `
    <section class="twin">
      <div class="header">
        <div>
          <span class="eyebrow">Digital Twin Locker</span>
          <h2>Stato dispositivo simulato</h2>
        </div>
        <span class="status" [class]="state()">{{ state() }}</span>
      </div>
      <div class="locker-model" [class]="state()">
        @for (door of [1, 2, 3, 4, 5, 6]; track door) {
          <div class="door" [class.active]="door === 2"><i></i><b></b></div>
        }
      </div>
      <div class="state-controls">
        @for (option of states; track option) {
          <button type="button" [class.active]="state() === option" (click)="state.set(option)">{{ option }}</button>
        }
      </div>
    </section>
  `,
  styles: [`
    .twin {
      padding: 20px;
      border-radius: 12px;
      color: white;
      background: linear-gradient(145deg, #0b1027, #121a39);
      border: 1px solid rgba(255,255,255,.1);
    }
    .header {
      display: flex;
      justify-content: space-between;
      gap: 16px;
      align-items: start;
      margin-bottom: 18px;
    }
    h2 { margin: 6px 0 0; font-family: "Space Grotesk"; }
    .locker-model {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 10px;
      padding: 14px;
      border-radius: 10px;
      background: rgba(255,255,255,.06);
      perspective: 800px;
    }
    .door {
      min-height: 108px;
      border-radius: 8px;
      position: relative;
      background: linear-gradient(145deg, rgba(255,255,255,.18), rgba(255,255,255,.06));
      border: 1px solid rgba(255,255,255,.12);
      transition: transform 300ms ease, box-shadow 300ms ease;
    }
    .door i {
      position: absolute;
      left: 12px;
      top: 12px;
      width: 26px;
      height: 18px;
      border-radius: 5px;
      background: #10f1d1;
      box-shadow: 0 0 20px rgba(16, 241, 209, 0.55);
    }
    .door b {
      position: absolute;
      right: 10px;
      top: 45px;
      width: 5px;
      height: 24px;
      border-radius: 99px;
      background: white;
    }
    .aperto .door.active { transform: rotateY(-28deg); }
    .offline .door i { background: var(--vx-danger); box-shadow: 0 0 20px rgba(255,92,122,.5); }
    .manutenzione .door i { background: var(--vx-warning); box-shadow: 0 0 20px rgba(255,176,32,.5); }
    .state-controls {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-top: 16px;
    }
    .state-controls button {
      border: 1px solid rgba(255,255,255,.14);
      border-radius: 8px;
      padding: 8px 10px;
      color: rgba(255,255,255,.74);
      background: rgba(255,255,255,.06);
      cursor: pointer;
      font-weight: 800;
    }
    .state-controls .active {
      color: white;
      background: linear-gradient(135deg, var(--vx-primary), var(--vx-secondary));
    }
  `]
})
export class DigitalTwinComponent {
  protected readonly states: LockerStatus[] = ['disponibile', 'occupato', 'aperto', 'offline', 'manutenzione'];
  protected readonly state = signal<LockerStatus>('disponibile');
}
